import React, { useContext } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "@asosteam/asos-web-react-i18n";
import StoreDataContext from "src/app/context/store-data";
import Button from "src/app/components/Button/Button";
import SuggestAnIdea from "src/assets/icons/suggest-an-idea.svg";
import iconsMap from "src/assets/iconsMap";
import { useGetAppDownloadUrl } from "src/app/hooks/useGetAppDownloadUrl";
import noticeError from "src/app/utilities/noticeError";
import styles from "./styles.module.css";

const URLS = {
  AU: "https://www.asos.com/au/",
  COM: "https://www.asos.com/",
  DE: "https://www.asos.com/de/",
  DK: "https://www.asos.com/dk/",
  ES: "https://www.asos.com/es/",
  FR: "https://www.asos.com/fr/",
  IT: "https://www.asos.com/it/",
  NL: "https://www.asos.com/nl/",
  PL: "https://www.asos.com/pl/",
  RU: "https://www.asos.com/ru/",
  SE: "https://www.asos.com/se/",
  US: "https://www.asos.com/us/",
};

function OrderSearchMessage({ formatTranslation }) {
  const { storeCode } = useContext(StoreDataContext);

  const storeUrl = new URL(URLS[storeCode] || URLS["COM"]);

  const { appDownloadUrl, isLoading } = useGetAppDownloadUrl({
    ctaRef: "help cc|order search|download app",
    defaultStoreUrl: storeUrl.toString(),
  });

  const Icon = iconsMap("Star");

  function handleClick() {
    if (!appDownloadUrl || isLoading) return;
    try {
      window.location.assign(appDownloadUrl);
    } catch (error) {
      noticeError("Failed to navigate to app URL, opening in new tab", error);
      window.open(appDownloadUrl, "_blank");
    }
  }

  return (
    <div className={styles.message}>
      <span className={styles.tip}>
        <SuggestAnIdea />
        {formatTranslation("cchp_order_search_tip_title")}
      </span>
      <h2 className={styles.title}>
        {formatTranslation("cchp_order_search_title")}
      </h2>
      <div className={styles.bannerContainer}>
        <div className={styles.bannerContent}>
          <h3 className={styles.bannerTitle}>
            {formatTranslation("cchp_order_search_banner_title")}
          </h3>
          <p className={styles.bannerDescription}>
            {formatTranslation("cchp_order_search_banner_description")}
          </p>
        </div>
        <div className={styles.buttons}>
          <Button onClick={handleClick}>
            {formatTranslation("cchp_order_search_button")}
          </Button>
          <div className={styles.ratingContainer}>
            {Icon &&
              Array.from({ length: 5 }).map((_, index) => (
                <Icon key={index} className={styles.starIcon} />
              ))}
            <span className={styles.ratingSpan} aria-hidden="true">
              {formatTranslation("cchp_order_search_button_description")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

OrderSearchMessage.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
};

export default withTranslation(OrderSearchMessage);
